import './collection.css';
import { useRef } from 'react';

// Import components
import Demo from './Demo.jsx';
import ContactRequest from '../../components/contact_request/ContactRequest';

const Collection = () => {
  const demoRef = useRef(null);
  const contentRef = useRef(null);
  
  const handleTitleClick = () => {
    // Scroll to the first section
    if (contentRef.current) {
      contentRef.current.scrollIntoView({ behavior: 'smooth' });
    }
    
    // Also adjust the camera in the demo
    if (demoRef.current) {
      demoRef.current.scrollToContent();
    }
  };
  
  return (
    <div className="collection-container">
      <div className="collection-header">
        <h2 onClick={handleTitleClick} className="clickable-title">
          Transform Your LiDAR Collection Capabilities
        </h2>
      </div>
      
      <Demo ref={demoRef} />
      
      <div className="collection-content">
        <section className="collection-section" ref={contentRef}>
          <h3>Precision Tasking Meets Intelligent Automation</h3>
          <p>
            At <strong>LiDAR Consultants</strong>, we streamline your collection processes through precise tasking of new acquisitions and intelligent automation powered by advanced AI. Our solutions are designed to enhance efficiency, maximize accuracy, and significantly reduce operational overhead.
          </p>
        </section>
        
        <section className="collection-section">
          <h3>Custom LiDAR Tasking</h3>
          <p>
            Leverage our expertise to schedule and acquire new LiDAR datasets exactly tailored to your project's needs. Whether your focus is infrastructure, environmental monitoring, urban planning, or resource management, our targeted acquisition strategies ensure comprehensive and high-quality data collection every time.
          </p>
        </section>
        
        <section className="collection-section">
          <h3>AI-Driven Workflow Automation</h3>
          <p>
            Transform your existing workflows with our cutting-edge AI solutions. By automating complex, repetitive collection tasks, our technology dramatically increases productivity, minimizes human error, and frees your team to focus on strategic objectives and innovation.
          </p>
        </section>
        
        <section className="collection-section">
          <h3>Benefits at a Glance:</h3>
          <ul>
            <li>Optimized data acquisition tailored to project specifications</li>
            <li>Enhanced productivity through AI automation</li>
            <li>Reduced operational costs and time-to-delivery</li>
            <li>Increased accuracy and consistency of LiDAR datasets</li>
          </ul>
          
          <p>
            Unlock your organization's full potential with <strong>LiDAR Consultants</strong>—where innovation meets actionable intelligence.
          </p>
        </section>
        
        <section className="cta-section">
          <h3>Ready to Elevate Your LiDAR Collection?</h3>
          <p>
            Our experts are ready to help you optimize your LiDAR collection strategy. Get in touch for a custom quote tailored to your specific project needs.
          </p>
          <ContactRequest />
        </section>
      </div>
    </div>
  );
};

export default Collection;